import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faWallet, faCreditCard, faArrowUpFromBracket, faCircleNotch, faUser } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { toast } from 'react-hot-toast';

function Deposit4() {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem('deposit.fileName')) {
        navigate('/deposit2', { replace: true })
    }else{
        setLoading(false);
    }
  }, [state, navigate])
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [symbol, setSymbol] = useState(() => {return state?.symbol ?? localStorage.getItem('deposit.symbol') ?? '';});
  const [method, setMethod] = useState(() => {return state?.method ?? localStorage.getItem('deposit.method') ?? '';});
  const [route, setRoute] = useState(() => {return state?.route ?? localStorage.getItem('deposit.route') ?? 'funding';});
  const [takeLoan, setTakeLoan] = useState(() => {return localStorage.getItem('deposit.takeLoan') ?? false;});
  const [loanID, setLoanID] = useState(() => {return localStorage.getItem('deposit.loanID') ?? '';});
  const [reference, setReference] = useState(() => {return localStorage.getItem('deposit.reference') ?? '';});
  const [amount, setAmount] = useState(() => {return state?.amount ?? localStorage.getItem('deposit.amount') ?? '';});
  const [fileName, setFileName] = useState(() => {return state?.fileName ?? localStorage.getItem('deposit.fileName') ?? '';});

  const ValidateDeposit = () =>{
    setLoading1(true);
    if(route == "funding"){
      fetch(`${process.env.REACT_APP_API_URL}controller/deposit.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
          "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_deposit: true, amount: amount, proof: fileName, method: method })
      })
      .then(response => response.json())
      .then(data => {
          if (data.status === "success") {
          setLoading1(false);
          toast.success(data.result);
          setTimeout(() => {
              navigate('/deposit', { replace: true })
          }, 2000);
          }else{
          toast.error(data.message);
          setLoading1(false);
          }
      })
      .catch(err => {
          console.error(err)
          setLoading1(false);
      })
    }else if(route == "signal" || route == "subscription"){
        let d_type = "";
        if(route == "signal"){
          d_type = "Signal";
        }else{
          d_type = "Subscription";
        }
        fetch(`${process.env.REACT_APP_API_URL}controller/deposit.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ btn_sdeposit: true, type : d_type, amount: amount, proof: fileName, method: method })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
            setLoading1(false);
            toast.success(data.result);
            setTimeout(() => {
                navigate('/deposit', { replace: true })
            }, 2000);
            }else{
            toast.error(data.message);
            setLoading1(false);
            }
        })
        .catch(err => {
            console.error(err)
            setLoading1(false);
        })
    }else if(route == "loanrepayment"){
      fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
          "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_payment: true, amount: amount, proof: fileName, method: method, loan_id : loanID, reference : reference })
      })
      .then(response => response.json())
      .then(data => {
          if (data.status === "success") {
          setLoading1(false);
          toast.success(data.result);
          setTimeout(() => {
              navigate('/loan', { replace: true })
          }, 2000);
          }else{
          toast.error(data.message);
          setLoading1(false);
          }
      })
      .catch(err => {
          console.error(err)
          setLoading1(false);
      })
    }else if(route == "equity"){
      fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
          "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_collateral: true, amount: amount, proof: fileName, method: method })
      })
      .then(response => response.json())
      .then(data => {
          if (data.status === "success") {
          setLoading1(false);
          toast.success(data.result);
          if(takeLoan && loanID){
            setTimeout(() => {
              navigate('/loanform', { 
                replace: true,
                state: { loan_id: loanID, casset: method, collateral: amount, collat: symbol }
              });
            }, 2000);
          }else{
            setTimeout(() => {
              navigate('/loan', { replace: true })
            }, 2000);
          }
          }else{
            toast.error(data.message);
            setLoading1(false);
          }
      })
      .catch(err => {
          console.error(err)
          setLoading1(false);
      })
    }else if(route == "401k"){
      fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
          "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_deposit: true, amount: amount, proof: fileName, method: method })
      })
      .then(response => response.json())
      .then(data => {
          if (data.status === "success") {
          setLoading1(false);
          toast.success(data.result);
          setTimeout(() => {
            navigate('/transaction', { replace: true })
          }, 2000);
          }else{
            toast.error(data.message);
            setLoading1(false);
          }
      })
      .catch(err => {
          console.error(err)
          setLoading1(false);
      })
    }
  }
  
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Make a Deposit</h5>
                        <p className="mb-0">Add funds to your trading account</p>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/deposit" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Type</p>
                          </Link>
                          <div style={{height:'3px',maxWidth:'200px',width:'100%'}} className="bg-prime"></div>
                          <Link to="/deposit1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Method</p>
                          </Link>
                          <div style={{height:'3px',maxWidth:'200px',width:'100%'}} className="bg-prime"></div>
                          <Link to="/deposit2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Details</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/deposit3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Payment Proof</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/deposit4" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12 largeSelect">
                              <h5 className="mb-4" style={{fontWeight:'900'}}>Review Your Deposit</h5>
                              <div className="mb-4 mycard p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <p className="mb-0 text-secondary fw-semibold">Method</p>
                                    <p className="mb-0 fw-bold">{method}</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="mb-0 text-secondary fw-semibold">Amount </p>
                                    <p className="mb-0 fw-bold">{amount} {symbol}</p>
                                </div>
                              </div>
                              <div className="mycard p-3 rounded-2" style={{backgroundColor:'#ff6b350d'}}>
                                <p className="mb-0 text-prime" style={{fontSize:'14px'}}>Your deposit will be review within 1-24 hours. You'll receive an email confirmation once approved.</p>
                              </div>
                              <hr/>
                              <div className="d-flex justify-content-end">
                                <div className={`myBtn mt-4 text-center px-4 py-3 rounded-2`} onClick={ValidateDeposit}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Submit Deposit'}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Deposit4